document.addEventListener('DOMContentLoaded', function() {
  class TabsSlider extends HTMLElement {
    constructor() {
      super();
      this.tabSlider = null; // Initialize the tabSlider property
    }
  
    connectedCallback() {
      this.initTabs();
      this.initSwiper();
    }  
    initTabs() {
      const tabsLinks = this.querySelectorAll('tabs-slider .swiper-filter button.button');
      const tabsSlides = this.querySelectorAll('tabs-slider .swiper-tabs .swiper-slide');
      tabsLinks.forEach((tabsLink) => {
        tabsLink.addEventListener('click', (event) => {        
          event.preventDefault();
          var filter = event.target.getAttribute('data-filter');
          console.log('filter:', filter);
          // update the tab links start
          tabsLinks.forEach(slide => slide.classList.remove('active'));
          event.target.classList.add("active");
          // update the tab links end
          // update the tabs start
          this.tabSlider.slideTo(filter);         
          /* 
          tabsSlides.forEach((tabsSlide) => {
            if (tabsSlide.classList.contains(filter)) {
              tabsSlide.style.display = '';
              console.log('tabsSlide:', tabsSlide);
            } else {
              tabsSlide.style.display = 'none';              
            }
          });
          console.log('tabSlider:', this.tabSlider); // Log the tabSlider instance
          
          // Update the Swiper instance
          this.tabSlider.updateSize();
          this.tabSlider.updateSlides();
          this.tabSlider.updateProgress();
          this.tabSlider.updateSlidesClasses();
          this.tabSlider.slideTo(0);
          this.tabSlider.scrollbar.updateSize();
          */

          return false;
        });
      });      
    }  
    initSwiper() {
      this.tabSlider = new Swiper(this.querySelector('.swiper-tabs'), {
        observer: true,
        slidesPerView: 1,
        runCallbacksOnInit: true,
        autoHeight: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        updateOnImagesReady: true,
        on: {
          slideChange: () => {
            // Sync active tab link with the current slide
            const currentIndex = this.tabSlider.realIndex; // Get the current slide index
            const tabsLinks = this.querySelectorAll('tabs-slider .swiper-filter button.button');
            
            // Remove 'active' class from all tabs and add it to the current one
            tabsLinks.forEach((link) => link.classList.remove('active'));
            const activeTab = tabsLinks[currentIndex];
            if (activeTab) {
              activeTab.classList.add('active');
            }
          },
        },
      });
    }
  }  
  customElements.define('tabs-slider', TabsSlider);
});



/*====================================*/
    // initSwiper() {
    //   this.tabSlider = new Swiper(this.querySelector('.swiper-tabs'), {
    //     observer: true,
    //     slidesPerView: 1,
    //     runCallbacksOnInit: true,
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev',
    //     },
    //     updateOnImagesReady: true,
    //   });
    //   /* 
    //   document.getElementById('tab_slide_01').addEventListener('click', function() {
    //       this.tabSlider.slideTo(1);
    //   });

    //   document.getElementById('tab_slide_02').addEventListener('click', function() {
    //       this.tabSlider.slideTo(2);
    //   });

    //   document.getElementById('tab_slide_03').addEventListener('click', function() {
    //       this.tabSlider.slideTo(3);
    //   });
    //   */
    // }